<template>
    <div class="bg-white">
        <app-modal-confirm
            ref="entry_modal_delete"
            :modal-header-title="$t('common.delete confirm title')"
            @confirmed="deleteEntry()"
        >
            <template v-slot:body>
                <p class="confirm-body">{{ $t("common.delete confirm") }}</p>
            </template>
        </app-modal-confirm>

        <validation-observer
            ref="form_create_entry"
            v-slot="{ passes, valid, validated }"
        >
            <form class="form-create form-horizontal" v-on:submit.prevent="passes(createOrUpdate)">
                <div class="card card-body">
                    <div v-if="idEditing">
                        <div class="form-group row">
                        <label class="col-xl-1 col-lg-2 col-sm-2">{{ $t("common.id") }}</label>
                        <div class="col-xl-5 col-lg-6 col-sm-6 p-t-8"> {{ entry.id }}</div>
                        </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-xl-1 col-lg-2 col-sm-2">{{ $t("small-category.name_big") }} <span class="app-require">＊</span></label>
                      <div class="col-xl-5 col-lg-6 col-sm-6">
                        <app-select
                          name="big_category_id"
                          rules="required"
                          :options-data="meta.big_category"
                          v-model="entry.big_category_id"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-xl-1 col-lg-2 col-sm-2">{{ $t("small-category.name_medium") }} <span class="app-require">＊</span></label>
                      <div class="col-xl-5 col-lg-6 col-sm-6">
                        <app-select
                          name="medium_category_id"
                          rules="required"
                          :options-data="meta.medium_category"
                          v-model="entry.medium_category_id"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-xl-1 col-lg-2 col-sm-2">{{ $t("common.name") }} <span class="app-require">＊</span></label>
                        <div class="col-xl-5 col-lg-6 col-sm-6">
                        <app-input
                            name="name"
                            type="string:40"
                            rules="required"
                            v-model="entry.name"
                        />
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="col-xl-1 col-lg-2 col-sm-2">{{ $t("common.note") }}</label>
                        <div class="col-xl-5 col-lg-6 col-sm-6">
                        <app-text
                            name="note"
                            type="string1024"
                            v-model="entry.note"
                        />
                        </div>
                    </div>

                    <div class="card-footer row justify-content-end gr-button">
                        <button type="button" :disabled="!valid && validated" class="btn btn-default m-r-10" @click="handlerCancelButton">
                        {{ $t('common.cancel') }}
                        </button>
                        <button type="button" class="btn btn btn-danger m-r-10" :disabled="!valid && validated" @click="handleDeleteConfirm" v-if="idEditing">
                            {{ $t('common.delete') }}
                        </button>
                        <button :disabled="!valid && validated" class="btn btn-primary" type="submit">
                            {{idEditing ?  $t('common.save') :  $t('common.create')}}
                        </button>
                    </div>
                </div>
            </form>
        </validation-observer>
    </div>
</template>
<script>
import {createHmac} from "crypto";
import {__noticeWarning} from "../../../utils";
import {ROUTES} from "@constants";
export default {
    name: "FormPage",
    components: {

    },
    data() {
        const id = this.$route.params.id
        return {
            entry: {
                apiKeys: [],
            },
            apiKeyId: null,
            meta: {
                big_category: [],
                medium_category: []
            },
            idEditing: id,
            isLineLink: '',
        }
    },

    watch : {
        'entry.big_category_id': async function (value) {
            if (value) {
                await this.getMetaData({big_category_id: value})
            } else {
                this.meta.medium_category = [{
                    id: "",
                    name: "--選択--"
                }]
            }
        },
    },

    mounted: function() {
        if (!this.idEditing) {
            this.getMetaData({});
        }

        if (this.idEditing) {
            this.$request.get(this.ENDPOINT.SMALL_CATEGORY_EDIT(this.idEditing)).then(res => {
                if (res.hasErrors()) {
                    this.redirectDefaultValue()
                }
                this.entry = res.data.data
            })
        }
    },

    methods: {

        getMetaData(params) {
            this.loading = false;
            this.$request.get(this.ENDPOINT.UI_HELPER_CHAT_BOT_CATEGORY, params).then(res => {
                this.meta = {
                    big_category: res.data.big_category,
                    medium_category: res.data.medium_category
                }
                this.meta.big_category.unshift({
                    id: "",
                    name: "--選択--"
                })
                this.meta.medium_category.unshift({
                    id: "",
                    name: "--選択--"
                })
            })
            this.loading = true;
        },

        handlerCancelButton() {
          if(this.$store.state.setting.prevRouter.name === ROUTES.ADMIN.SMALL_CATEGORY_LIST) {
            this.__redirectBack()
          } else {
            this.redirectDefaultValue()
          }
        },
        redirectBack() {
            this.$router.go(-1);
        },
        async createOrUpdate() {
            let res = null;
            let msg = "";
            let params = _.cloneDeep(this.entry);
            if (this.idEditing) {
                res = await this.$request.patch(this.ENDPOINT.SMALL_CATEGORY_EDIT(this.idEditing), params);
                msg = this.$t("common.msg update ok")
            } else {
                params.category_type = 2;
                res = await this.$request.post(this.ENDPOINT.SMALL_CATEGORY_CREATE, params);
                msg = this.$t("common.msg create ok")
            }
            if (res.hasErrors()) {
                this.__noticeError(res.data.error_msg != undefined ? res.data.error_msg : this.$t('common.error'));
            } else {
                this.__noticeSuccess(msg);
                await this.redirectDefaultValue()
            }
        },
        handleDeleteConfirm() {
            this.$refs.entry_modal_delete.show();
        },
        async deleteEntry() {
            const res = await this.$request.delete(this.ENDPOINT.SMALL_CATEGORY_DELETE(this.idEditing));
            if (!res.hasErrors()) {
                this.__noticeSuccess(this.$t("common.msg delete ok"));
                await this.redirectDefaultValue();
            } else {
                this.__noticeError(res.data.error_msg != undefined ? res.data.error_msg : this.$t('common.error'));
              this.$refs.entry_modal_delete.hide();
            }
        },
        async redirectDefaultValue() {
            await this.$router.push({
                name: this.ROUTES.ADMIN.SMALL_CATEGORY_LIST, query: {
                    'filters.big_category_id.equal': 'all',
                }
            });
        },
    },
}
</script>
